import { CallToAction } from 'components/CallToAction'
import Link from 'components/Link'
import React from 'react'

export interface IProps {
    title: string
    url: string
    items?: {
        title: string
        url: string
    }[]
}

export const LinkListItem = ({ title, url, items, enable }: IProps) => {
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return null
    }
    return (
        <div>
            {items && (
                <ul
                    key={url}
                    className="m-0 space-y-[1px] border-l border-b border-dashed border-gray-accent-light px-2 pt-8 pb-4 last:border-r dark:border-gray-accent-dark lg:border-b-0 lg:pt-16 lg:pb-12"
                >
                    <li key={url} className="list-none">
                        <h4 className="mb-0 text-[17px]">
                            <Link
                                to={url}
                                className="relative box-border flex rounded px-3 py-1.5 transition-all hover:bg-gray-accent-light hover:text-red hover:opacity-100 active:top-[.5px] active:scale-[.99] dark:opacity-80 hover:dark:bg-gray-accent-dark"
                            >
                                {title}
                            </Link>
                        </h4>
                    </li>
                    {items?.length > 0 &&
                        items
                            .filter(
                                ({ enable }) =>
                                    !(enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS)
                            )
                            .map(({ title, url, enable }, index) => (
                                <li key={`item-${index}`} className="list-none text-[15px]">
                                    <Link
                                        to={url}
                                        className="relative box-border flex rounded px-3 py-1.5 font-medium transition-all hover:bg-gray-accent-light hover:opacity-100 active:top-[.5px] active:scale-[.99] dark:opacity-80 hover:dark:bg-gray-accent-dark"
                                    >
                                        {title}
                                    </Link>
                                </li>
                            ))}
                </ul>
            )}
        </div>
    )
}
